"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _prismicConfiguration = require("../prismic-configuration");
var _agent = require("@deosite/agent");
var _createSearchUrl = require("@deosite/helpers/createSearchUrl");
var _saleBanner = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/saleBanner"));
var _prismicDataMapper = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper"));
var _blogger = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/blogger"));
var _mapProductDataNew = _interopRequireDefault(require("@deosite/helpers/mapProductDataNew"));
var _cache = require("@deosite/helpers/cache");
var _prismicHelper = require("../prismicHelper");
var _prismicErrorHandle = _interopRequireDefault(require("@deosite/helpers/prismicErrorHandle"));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(type, uid, language) {
    var withPrefix,
      _ret,
      _getLanguage,
      cacheFileExist,
      cachedRequest,
      _args6 = arguments;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            withPrefix = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : true;
            _context6.prev = 1;
            return _context6.delegateYield(/*#__PURE__*/_regenerator["default"].mark(function _callee5(_response$data, _response$data$body, _response$data2, _response$data3, _response$data4, _relatedArticlesConte, _response$data5, _response$data5$saleb, _response$data$seotit, _response$data$seodes) {
              var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, linkedContent, linkedContentResponse, linkedContentResponseData, mappedResponse, getBlogger, getSalesBanner, getProducts, getRelated, featuredProducts, relatedFirst, relatedSecond, relatedArticlesIds, relatedArticlesContent, bloggersIDs, bloggersToFetch, bloggersResponse, mappedBloggers, _i, _Object$entries, _Object$entries$_i, key, value, mappedArticles, saleBannerUid, saleBanner, productsData, mappedSaleBanner, seoTitle, seoDescription;
              return _regenerator["default"].wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return (0, _prismicHelper.getLanguage)({
                        language: language,
                        filename: uid
                      });
                    case 2:
                      _yield$getLanguage = _context5.sent;
                      cacheFileExist = _yield$getLanguage.cacheFileExist;
                      cachedRequest = _yield$getLanguage.cachedRequest;
                      lang = _yield$getLanguage.lang;
                      cacheFilePath = _yield$getLanguage.cacheFilePath;
                      if (!cacheFileExist) {
                        _context5.next = 9;
                        break;
                      }
                      return _context5.abrupt("return", {
                        v: cachedRequest
                      });
                    case 9:
                      _context5.next = 11;
                      return (0, _prismicHelper.getResponsePrismicByUID)({
                        type: type,
                        uid: uid,
                        lang: lang,
                        withPrefix: withPrefix
                      });
                    case 11:
                      response = _context5.sent;
                      if (response) {
                        _context5.next = 14;
                        break;
                      }
                      return _context5.abrupt("return", {
                        v: false
                      });
                    case 14:
                      linkedContent = [];
                      (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.filter(function (item) {
                        if (item.slice_type === "linked_content") {
                          linkedContent.push(item);
                        }
                      });
                      _context5.next = 18;
                      return Promise.all(linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.map(function (item) {
                        return (0, _prismicConfiguration.Client)().getByID(item.primary.linked_content.id);
                      }));
                    case 18:
                      linkedContentResponse = _context5.sent;
                      linkedContentResponseData = [];
                      linkedContentResponse.length > 0 ? linkedContentResponse.map(function (element) {
                        linkedContentResponseData.push(element.data.body[0]);
                      }) : linkedContentResponseData = false;
                      response.linkedContentResponse = linkedContentResponseData;
                      mappedResponse = response && (0, _prismicDataMapper["default"])(response);
                      getBlogger = /*#__PURE__*/function () {
                        var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(bloggerId) {
                          return _regenerator["default"].wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return (0, _prismicConfiguration.Client)().getByID(bloggerId);
                                case 2:
                                  return _context.abrupt("return", _context.sent);
                                case 3:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }));
                        return function getBlogger(_x4) {
                          return _ref2.apply(this, arguments);
                        };
                      }();
                      getSalesBanner = /*#__PURE__*/function () {
                        var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(bannerId) {
                          return _regenerator["default"].wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.next = 2;
                                  return (0, _prismicConfiguration.Client)().getByID(bannerId);
                                case 2:
                                  return _context2.abrupt("return", _context2.sent);
                                case 3:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2);
                        }));
                        return function getSalesBanner(_x5) {
                          return _ref3.apply(this, arguments);
                        };
                      }();
                      getProducts = /*#__PURE__*/function () {
                        var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(productsIDs) {
                          var productsInPrismicOrder, _response;
                          return _regenerator["default"].wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  if (productsIDs) {
                                    _context3.next = 2;
                                    break;
                                  }
                                  return _context3.abrupt("return");
                                case 2:
                                  productsInPrismicOrder = [];
                                  _context3.prev = 3;
                                  _context3.next = 6;
                                  return _agent.requests.get((0, _createSearchUrl.createSearchUrl)("/products", productsIDs.map(function (sku) {
                                    return {
                                      field: "sku",
                                      value: sku,
                                      condition_type: "in",
                                      connector: _createSearchUrl.CONNECTORS.OR
                                    };
                                  })), true, null, language);
                                case 6:
                                  _response = _context3.sent;
                                  (_response === null || _response === void 0 ? void 0 : _response.total_count) > 0 && productsIDs.map(function (productID) {
                                    _response.items.map(function (resultItem) {
                                      if (productID === resultItem.sku) {
                                        productsInPrismicOrder.push(resultItem);
                                      }
                                    });
                                  });
                                  _context3.next = 13;
                                  break;
                                case 10:
                                  _context3.prev = 10;
                                  _context3.t0 = _context3["catch"](3);
                                  console.log("usePrismic - getProducts - ".concat(_context3.t0));
                                case 13:
                                  return _context3.abrupt("return", (0, _mapProductDataNew["default"])(productsInPrismicOrder));
                                case 14:
                                case "end":
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, null, [[3, 10]]);
                        }));
                        return function getProducts(_x6) {
                          return _ref4.apply(this, arguments);
                        };
                      }();
                      getRelated = /*#__PURE__*/function () {
                        var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(relatedIds) {
                          return _regenerator["default"].wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  _context4.next = 2;
                                  return (0, _prismicConfiguration.Client)().getByIDs(relatedIds);
                                case 2:
                                  return _context4.abrupt("return", _context4.sent);
                                case 3:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4);
                        }));
                        return function getRelated(_x7) {
                          return _ref5.apply(this, arguments);
                        };
                      }();
                      featuredProducts = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.featured_products;
                      relatedFirst = (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.related_article_first;
                      relatedSecond = (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.related_article_second;
                      relatedArticlesIds = [];
                      (relatedFirst === null || relatedFirst === void 0 ? void 0 : relatedFirst.id) && relatedArticlesIds.push(relatedFirst.id);
                      (relatedSecond === null || relatedSecond === void 0 ? void 0 : relatedSecond.id) && relatedArticlesIds.push(relatedSecond.id);
                      if (!(relatedArticlesIds.length > 0)) {
                        _context5.next = 39;
                        break;
                      }
                      _context5.next = 36;
                      return getRelated(relatedArticlesIds);
                    case 36:
                      _context5.t0 = _context5.sent;
                      _context5.next = 40;
                      break;
                    case 39:
                      _context5.t0 = "";
                    case 40:
                      relatedArticlesContent = _context5.t0;
                      bloggersIDs = [];
                      mappedResponse.inspirations.map(function (inspiration) {
                        if (inspiration.bloggerId) {
                          bloggersIDs.push(inspiration.bloggerId);
                        } else {
                          bloggersIDs.push("0");
                        }
                      });
                      if (mappedResponse.blogger) {
                        bloggersIDs.push(mappedResponse.blogger);
                      }
                      bloggersToFetch = Array.from(new Set(bloggersIDs));
                      _context5.next = 47;
                      return Promise.all(bloggersToFetch.map(function (id) {
                        return id === "0" ? id : getBlogger(id);
                      }));
                    case 47:
                      bloggersResponse = _context5.sent;
                      mappedBloggers = bloggersResponse.map(function (blogger) {
                        return blogger === "0" ? blogger : (0, _blogger["default"])(blogger);
                      });
                      for (_i = 0, _Object$entries = Object.entries(mappedResponse); _i < _Object$entries.length; _i++) {
                        _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        if (Array.isArray(value)) {
                          value.map(function (content) {
                            mappedBloggers.map(function (blogger) {
                              if (blogger.id === content.bloggerId) {
                                content.influencerData = blogger;
                              }
                            });
                          });
                        }
                      }
                      mappedArticles = [];
                      (relatedArticlesContent === null || relatedArticlesContent === void 0 ? void 0 : relatedArticlesContent.results) && ((_relatedArticlesConte = relatedArticlesContent.results) === null || _relatedArticlesConte === void 0 ? void 0 : _relatedArticlesConte.map(function (result) {
                        var _result$article$conte;
                        result = (0, _prismicDataMapper["default"])(result);
                        var image = {};
                        (_result$article$conte = result.article.content) === null || _result$article$conte === void 0 ? void 0 : _result$article$conte.map(function (articleContent) {
                          if (articleContent.type === "image" && articleContent.mode === "width with larger margin") {
                            image = articleContent.image;
                          }
                        });
                        mappedArticles.push({
                          title: result.article.title,
                          description: result.article.subtitle,
                          route: result.url,
                          image: image
                        });
                      }));
                      saleBannerUid = (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$saleb = _response$data5.salebanner) === null || _response$data5$saleb === void 0 ? void 0 : _response$data5$saleb.id;
                      if (!saleBannerUid) {
                        _context5.next = 59;
                        break;
                      }
                      _context5.next = 56;
                      return getSalesBanner(saleBannerUid);
                    case 56:
                      _context5.t1 = _context5.sent;
                      _context5.next = 60;
                      break;
                    case 59:
                      _context5.t1 = false;
                    case 60:
                      saleBanner = _context5.t1;
                      if (!(featuredProducts !== null && featuredProducts !== void 0 && featuredProducts.length)) {
                        _context5.next = 67;
                        break;
                      }
                      _context5.next = 64;
                      return getProducts(featuredProducts.replace(/\s+/g, "").split(","));
                    case 64:
                      _context5.t2 = _context5.sent;
                      _context5.next = 68;
                      break;
                    case 67:
                      _context5.t2 = [];
                    case 68:
                      productsData = _context5.t2;
                      mappedSaleBanner = saleBanner ? (0, _saleBanner["default"])(saleBanner.data) : false;
                      seoTitle = ((_response$data$seotit = response.data.seotitle) === null || _response$data$seotit === void 0 ? void 0 : _response$data$seotit.length) > 0 ? response.data.seotitle[0].text : false;
                      seoDescription = ((_response$data$seodes = response.data.seodescription) === null || _response$data$seodes === void 0 ? void 0 : _response$data$seodes.length) > 0 ? response.data.seodescription[0].text : false;
                      _context5.next = 74;
                      return (0, _cache.saveCacheFile)({
                        cacheFilePath: cacheFilePath,
                        filenameCategoryCache: "".concat(uid, ".json"),
                        result: {
                          seoTitle: seoTitle,
                          seoDescription: seoDescription,
                          content: mappedResponse,
                          blogger: mappedBloggers,
                          products: productsData,
                          related: mappedArticles,
                          saleBanner: mappedSaleBanner
                        }
                      });
                    case 74:
                      return _context5.abrupt("return", {
                        v: {
                          seoTitle: seoTitle,
                          seoDescription: seoDescription,
                          content: mappedResponse,
                          blogger: mappedBloggers,
                          products: productsData,
                          related: mappedArticles,
                          saleBanner: mappedSaleBanner
                        }
                      });
                    case 75:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            })(), "t0", 3);
          case 3:
            _ret = _context6.t0;
            if (!(typeof _ret === "object")) {
              _context6.next = 6;
              break;
            }
            return _context6.abrupt("return", _ret.v);
          case 6:
            _context6.next = 14;
            break;
          case 8:
            _context6.prev = 8;
            _context6.t1 = _context6["catch"](1);
            _getLanguage = (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            }), cacheFileExist = _getLanguage.cacheFileExist, cachedRequest = _getLanguage.cachedRequest;
            if (!cacheFileExist) {
              _context6.next = 13;
              break;
            }
            return _context6.abrupt("return", cachedRequest);
          case 13:
            return _context6.abrupt("return", (0, _prismicErrorHandle["default"])(_context6.t1, "Prismic - type: ".concat(type, " uid: ").concat(uid, " - ").concat(_context6.t1)));
          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 8]]);
  }));
  return function fetcher(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;